export function SettingsPage() {
  return (
    <div style={{ maxWidth: 'var(--content-max-width)' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 8,
          padding: '80px 0',
          color: 'var(--text-tertiary)',
        }}
      >
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden style={{ opacity: 0.4 }}>
          <circle cx="20" cy="20" r="5" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M20 4v4M20 32v4M4 20h4M32 20h4M7.5 7.5l2.8 2.8M29.7 29.7l2.8 2.8M7.5 32.5l2.8-2.8M29.7 10.3l2.8-2.8"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
          />
        </svg>
        <p style={{ margin: 0, fontWeight: 500, fontSize: 'var(--text-sm)' }}>
          Settings — coming soon
        </p>
        <p style={{ margin: 0, fontSize: 'var(--text-sm)', color: 'var(--text-placeholder)' }}>
          System settings and preferences
        </p>
      </div>
    </div>
  );
}
